import _ from "lodash";

export const buildReviewsStylesheet = (builder, device, cta, element, variant = {}) => {
    let options = { ...element.options };
    const variantOptions = variant?.options || {};

    const reviewsArrowSize = options["reviews-arrow-size"] || 12;

    let reviewsOuterAlignment;
    if (options["cf-alignment"] == "cf-left") {
      reviewsOuterAlignment = "justify-content: flex-start !important; margin-right: auto !important; margin-left: unset !important;"
    } else if (options["cf-alignment"] == "cf-center") {
      reviewsOuterAlignment = "justify-content: center !important; margin-left: auto !important; margin-right: auto !important;"
    } else if (options["cf-alignment"] == "cf-right") {
      reviewsOuterAlignment = "justify-content: flex-end !important; margin-left: auto !important; margin-right: unset !important;"
    }

    let reviewsInnerAlignment = "";
    let reviewsInnerAlignmentFlex = "";
    let reviewsInnerAlignmentFlexItems = "";
    const innerAlignment = (options["cf-inner-alignment"] && options["cf-inner-alignment"].trim()) || "left";
    if (innerAlignment === "left" || innerAlignment === "") {
      reviewsInnerAlignment = "text-align: left !important;";
      reviewsInnerAlignmentFlex = "justify-content: flex-start !important;";
      reviewsInnerAlignmentFlexItems = "align-items: flex-start !important;";
    } else if (innerAlignment === "center") {
      reviewsInnerAlignment = "text-align: center !important;";
      reviewsInnerAlignmentFlex = "justify-content: center !important;";
      reviewsInnerAlignmentFlexItems = "align-items: center !important;";
    } else if (innerAlignment === "right") {
      reviewsInnerAlignment = "text-align: right !important;";
      reviewsInnerAlignmentFlex = "justify-content: flex-end !important;";
      reviewsInnerAlignmentFlexItems = "align-items: flex-end !important;";
    }

    const containerWidth = options['reviews-container-width'];
    const containerHeight = options['reviews-container-height'];
    const contentVerticalSpacing = options['reviews-content-vertical-spacing'];
    const desktopReviewsPerSlide = parseInt(options['reviews-per-row']) || 3;
    const reviewsVideoTextColor = options["reviews-video-background-text-color"] || variantOptions["reviews-video-background-text-color"];
    const reviewsVideoBgRatingColor = options["reviews-video-bg-rating-color"] || variantOptions["reviews-video-bg-rating-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgTitleColor = options["reviews-video-bg-title-color"] || variantOptions["reviews-video-bg-title-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgContentColor = options["reviews-video-bg-content-color"] || variantOptions["reviews-video-bg-content-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgCustomerNameColor = options["reviews-video-bg-customer-name-color"] || variantOptions["reviews-video-bg-customer-name-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgCustomerTitleColor = options["reviews-video-bg-customer-title-color"] || variantOptions["reviews-video-bg-customer-title-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgDateColor = options["reviews-video-bg-date-color"] || variantOptions["reviews-video-bg-date-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgSourceColor = options["reviews-video-bg-source-color"] || variantOptions["reviews-video-bg-source-color"] || reviewsVideoTextColor || '#fff';

    const ratingStarColor = element.options["rating-star-color"];
    const ratingStarSize = element.options["rating-star-size"];

    const titleFontFamily = element.options["title-font-family"];
    const titleFontWeight =
      element.options["title-font-weight"] ||
      variantOptions["reviews-title-font-weight"] ||
      "700";
    const titleFontSize = element.options["title-font-size"];
    const titleFontLineHeight = element.options["title-font-line-height"];
    const titleFontColor = element.options["title-font-color"];

    const contentFontFamily = element.options["content-font-family"];
    const contentFontWeight = element.options["content-font-weight"];
    const contentFontSize = element.options["content-font-size"];
    const contentFontLineHeight = element.options["content-font-line-height"];
    const contentFontColor =
      element.options["content-font-color"] ||
      variantOptions["reviews-content-font-color"] ||
      "#696969";

    const customerProfileNameFontFamily = element.options["customer-profile-name-font-family"];
    const customerProfileNameFontWeight = element.options["customer-profile-name-font-weight"];
    const customerProfileNameFontSize =
      element.options["customer-profile-name-font-size"] ||
      variantOptions["reviews-customer-profile-name-font-size"] ||
      "14";
    const customerProfileNameFontLineHeight = element.options["customer-profile-name-font-line-height"];
    const customerProfileNameFontColor = element.options["customer-profile-name-font-color"];

    const customerProfileTitleFontFamily = element.options["customer-profile-title-font-family"];
    const customerProfileTitleFontWeight = element.options["customer-profile-title-font-weight"];
    const customerProfileTitleFontSize =
      element.options["customer-profile-title-font-size"] ||
      variantOptions["reviews-customer-profile-title-font-size"] ||
      "12";
    const customerProfileTitleFontLineHeight = element.options["customer-profile-title-font-line-height"];
    const customerProfileTitleFontColor =
      element.options["customer-profile-title-font-color"] ||
      variantOptions["reviews-customer-profile-title-font-color"] ||
      "#696969";

    const customerProfileAvatarWidth = element.options["customer-profile-avatar-width"];
    const customerProfileAvatarHeight = element.options["customer-profile-avatar-height"];
    let customerProfileAvatarRadius = "";
    if (element.options["customer-profile-avatar-radius"] == "cf-not-rounded") customerProfileAvatarRadius = "0px";
    if (element.options["customer-profile-avatar-radius"] == "cf-slightly-rounded") customerProfileAvatarRadius = "4px";
    if (element.options["customer-profile-avatar-radius"] == "cf-fully-rounded") customerProfileAvatarRadius = "100px";
    if (element.options["customer-profile-avatar-radius"] == "custom") {
      customerProfileAvatarRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          customerProfileAvatarRadius += `${
            _.isNil(element.options["customer-profile-avatar-radius-" + side]) == false
              ? element.options["customer-profile-avatar-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let brandLogoRadius = "";
    if (element.options["brand-logo-radius"] == "cf-not-rounded") brandLogoRadius = "0px";
    if (element.options["brand-logo-radius"] == "cf-slightly-rounded") brandLogoRadius = "4px";
    if (element.options["brand-logo-radius"] == "cf-fully-rounded") brandLogoRadius = "100px";
    if (element.options["brand-logo-radius"] == "custom") {
      brandLogoRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          brandLogoRadius += `${
            _.isNil(element.options["brand-logo-radius-" + side]) == false
              ? element.options["brand-logo-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    const brandLogoWidth = element.options["brand-logo-width"];
    const brandLogoHeight = element.options["brand-logo-height"];

    const videoWidth = element.options["video-width"];
    const videoHeight = element.options["video-height"];
    const reviewsVideoOverlayColor = element.options["reviews-video-overlay-color"];

    const dateFontFamily = element.options["date-font-family"];
    const dateFontWeight = element.options["date-font-weight"];
    const dateFontSize = element.options["date-font-size"];
    const dateFontLineHeight = element.options["date-font-line-height"];
    const dateFontColor =
      element.options["date-font-color"] ||
      variantOptions["reviews-date-font-color"] ||
      "#696969";

    const sourceFontFamily = element.options["source-font-family"];
    const sourceFontWeight = element.options["source-font-weight"];
    const sourceFontSize = element.options["source-font-size"];
    const sourceFontLineHeight = element.options["source-font-line-height"];
    const sourceFontColor = element.options["source-font-color"];

    const contentFlow = element.options['slider-enabled'] == 'true' ? 'rows' : element.options['content-flow'];

    const reviewsBackgroundColor = element.options["reviews-background-color"];
    const reviewsBorderStyle = element.options["reviews-border-style"];
    const reviewsBorderColor = element.options["reviews-border-color"];
    let reviewsBorderRounding;
    if (element.options["reviews-border-rounding"] == "cf-not-rounded") { reviewsBorderRounding = "0px" }
    if (element.options["reviews-border-rounding"] == "cf-slightly-rounded") { reviewsBorderRounding = "4px" }
    if (element.options["reviews-border-rounding"] == "cf-fully-rounded") { reviewsBorderRounding = "100px" }
    if (element.options["reviews-border-rounding"] == "custom") {
      reviewsBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          reviewsBorderRounding += `${
            _.isNil(element.options["reviews-border-rounding-" + side]) == false
              ? element.options["reviews-border-rounding-" + side]
              : "4"
          }px `;
        }
      );
    }

    let desktopStyles = `
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-element {
        ${containerWidth ? `max-width: ${containerWidth}px; width: 100%;` : ''}
        ${reviewsOuterAlignment ? reviewsOuterAlignment : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-title,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content-type.cf-reviews-title {
        display: block !important;
        ${reviewsInnerAlignment}
        ${titleFontSize ? `font-size: ${titleFontSize}px !important;` : ''}
        ${titleFontLineHeight ? `line-height: ${titleFontLineHeight}px !important;` : ''}
        ${titleFontFamily && titleFontFamily !== 'inherit' ? `font-family: ${titleFontFamily}, sans-serif !important;` : ''}
        ${titleFontWeight ? `font-weight: ${titleFontWeight} !important;` : ''}
        ${titleFontColor ? `color: ${titleFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content {
        max-width: 100%;
        ${reviewsInnerAlignment}
        ${contentFontSize ? `font-size: ${contentFontSize}px !important;` : ''}
        ${contentFontLineHeight ? `line-height: ${contentFontLineHeight}px !important;` : ''}
        ${contentFontFamily && contentFontFamily !== 'inherit' ? `font-family: ${contentFontFamily}, sans-serif !important;` : ''}
        ${contentFontWeight ? `font-weight: ${contentFontWeight} !important;` : ''}
        ${contentFontColor ? `color: ${contentFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-profile-name {
        text-align: left !important;
        ${customerProfileNameFontSize ? `font-size: ${customerProfileNameFontSize}px !important;` : ''}
        ${customerProfileNameFontLineHeight ? `line-height: ${customerProfileNameFontLineHeight}px !important;` : ''}
        ${customerProfileNameFontFamily && customerProfileNameFontFamily !== 'inherit' ? `font-family: ${customerProfileNameFontFamily}, sans-serif !important;` : ''}
        ${customerProfileNameFontWeight ? `font-weight: ${customerProfileNameFontWeight} !important;` : ''}
        ${customerProfileNameFontColor ? `color: ${customerProfileNameFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-profile-title {
        width: fit-content;
        text-align: left !important;
        ${customerProfileTitleFontSize ? `font-size: ${customerProfileTitleFontSize}px !important;` : ''}
        ${customerProfileTitleFontLineHeight ? `line-height: ${customerProfileTitleFontLineHeight}px !important;` : ''}
        ${customerProfileTitleFontFamily && customerProfileTitleFontFamily !== 'inherit' ? `font-family: ${customerProfileTitleFontFamily}, sans-serif !important;` : ''}
        ${customerProfileTitleFontWeight ? `font-weight: ${customerProfileTitleFontWeight} !important;` : ''}
        ${customerProfileTitleFontColor ? `color: ${customerProfileTitleFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-profile-avatar img {
        max-width: 100%;
        ${customerProfileAvatarWidth ? `width: ${customerProfileAvatarWidth}px !important;` : 'width: 37px;'}
        ${customerProfileAvatarHeight ? `height: ${customerProfileAvatarHeight}px !important;` : ''}
        ${customerProfileAvatarRadius ? `border-radius: ${customerProfileAvatarRadius} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-brand-logo img {
        max-width: 100%;
        ${brandLogoWidth ? `width: ${brandLogoWidth}px !important;` : ''}
        ${brandLogoHeight ? `height: ${brandLogoHeight}px !important;` : ''}
        ${brandLogoRadius ? `border-radius: ${brandLogoRadius} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-inline,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-left,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-right {
        ${videoWidth ? `width: ${videoWidth}px !important;` : ''}
        ${videoHeight ? `height: ${videoHeight}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-date {
        ${reviewsInnerAlignment}
        ${dateFontSize ? `font-size: ${dateFontSize}px !important;` : ''}
        ${dateFontLineHeight ? `line-height: ${dateFontLineHeight}px !important;` : ''}
        ${dateFontFamily && dateFontFamily !== 'inherit' ? `font-family: ${dateFontFamily}, sans-serif !important;` : ''}
        ${dateFontWeight ? `font-weight: ${dateFontWeight} !important;` : ''}
        ${dateFontColor ? `color: ${dateFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-element * {
        font-family: Helvetica, Arial, sans-serif;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-source {
        display: flex;
        align-items: center;
        gap: 8px;
        ${reviewsInnerAlignmentFlex}
        ${sourceFontSize ? `font-size: ${sourceFontSize}px !important;` : ''}
        ${sourceFontLineHeight ? `line-height: ${sourceFontLineHeight}px !important;` : ''}
        ${sourceFontFamily && sourceFontFamily !== 'inherit' ? `font-family: ${sourceFontFamily}, sans-serif !important;` : ''}
        ${sourceFontWeight ? `font-weight: ${sourceFontWeight} !important;` : ''}
        ${sourceFontColor ? `color: ${sourceFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-source * {
        ${sourceFontFamily && sourceFontFamily !== 'inherit' ? `font-family: ${sourceFontFamily}, sans-serif !important;` : ''}
        ${sourceFontWeight ? `font-weight: ${sourceFontWeight} !important;` : ''}
        ${sourceFontColor ? `color: ${sourceFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-container {
        position: relative;
        width: 100%;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-profile {
        display: flex;
        gap: 10px;
        align-items: center;
        ${reviewsInnerAlignmentFlex}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-column-wrapper {
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: flex-start !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content-box {
        ${containerHeight ? `min-height: ${containerHeight}px;` : ''}
        ${reviewsBackgroundColor ? `background: ${reviewsBackgroundColor};` : ''}
        ${reviewsBorderStyle ? 'border-style: ' + reviewsBorderStyle + ';' : ''}
        ${reviewsBorderColor ? 'border-color: ' + reviewsBorderColor + ';' : ''}
        ${_.isNil(options["reviews-border-width"]) == false ? 'border-width: ' + options["reviews-border-width"] + 'px;' : ''}
        ${_.isNil(options["reviews-border-width-left"]) == false ? 'border-left-width: ' + options["reviews-border-width-left"] + 'px;' : _.isNil(options["reviews-border-width"]) == false ? 'border-left-width: ' + options["reviews-border-width"] + 'px;' : ''}
        ${_.isNil(options["reviews-border-width-right"]) == false ? 'border-right-width: ' + options["reviews-border-width-right"] + 'px;' : _.isNil(options["reviews-border-width"]) == false ? 'border-right-width: ' + options["reviews-border-width"] + 'px;' : ''}
        ${_.isNil(options["reviews-border-width-top"]) == false ? 'border-top-width: ' + options["reviews-border-width-top"] + 'px;' : _.isNil(options["reviews-border-width"]) == false ? 'border-top-width: ' + options["reviews-border-width"] + 'px;' : ''}
        ${_.isNil(options["reviews-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["reviews-border-width-bottom"] + 'px;' : _.isNil(options["reviews-border-width"]) == false ? 'border-bottom-width: ' + options["reviews-border-width"] + 'px;' : ''}
        ${reviewsBorderRounding ? 'border-radius: ' + reviewsBorderRounding + ';' : ''}
        ${reviewsInnerAlignmentFlexItems}
        ${reviewsInnerAlignment}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-horizontal .cf-reviews-grid {
        ${contentFlow === 'collage' ? `max-width: ${100 / desktopReviewsPerSlide}%; width: 100%;` : ''}
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        justify-content: flex-start;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-horizontal .cf-reviews-slide-content {
        display: flex;
        flex-shrink: 0;
        gap: 20px;
        align-items: stretch;
        justify-content: flex-start;
        width: 100%;
        ${containerWidth ? `max-width: 100%;` : `max-width: 1400px;`}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-vertical .cf-reviews-grid {
        display: flex;
        flex-direction: column;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-vertical .cf-reviews-content-box {
        margin-top: 15px;
        margin-bottom: 15px;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-vertical .cf-reviews-slide-content {
        display: flex;
        flex-direction: column;
        gap: 25px;
        align-items: stretch;
        width: 100%;
        ${containerWidth ? `max-width: 100%;` : `max-width: 1400px;`}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content-type {
        max-width: 100%;
        ${reviewsInnerAlignment}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-horizontal.cf-reviews-slider-disabled {
        ${contentFlow === 'collage' ? 'display: flex; gap: 20px;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-horizontal.cf-reviews-slider-disabled .cf-reviews-content-box {
        flex-grow: 0;
        width: ${contentFlow === 'collage' ? '100%' : `calc((100% - ${(desktopReviewsPerSlide - 1) * 20}px) / ${desktopReviewsPerSlide})`};
        flex-shrink: 0;
        box-sizing: border-box;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-default .cf-reviews-slider-wrapper {
        position: relative;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-inline .cf-reviews-slider-wrapper {
        position: relative;
        padding: 0;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-slider {
        width: 100%;
        overflow: hidden;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-slides {
        display: flex;
        width: 100%;
        transition: transform 0.3s ease-in-out;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-default .cf-reviews-slide {
        min-width: 100%;
        display: flex;
        justify-content: center;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-inline .cf-reviews-slide {
        min-width: 100%;
        display: flex;
        justify-content: center;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-inline .cf-reviews-slide-content {
        padding-right: 0;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-horizontal .cf-reviews-content-box {
        flex-grow: 0;
        width: ${contentFlow === 'collage' ? '100%' : `calc((100% - ${(desktopReviewsPerSlide - 1) * 20}px) / ${desktopReviewsPerSlide})`};
        flex-shrink: 0;
        box-sizing: border-box;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-default {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: #ffffff;
        border: 2px solid #e5e5e5;
        border-radius: 50%;
        width: ${parseInt(reviewsArrowSize) + 20}px !important;
        height: ${parseInt(reviewsArrowSize) + 20}px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #666;
        z-index: 10;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-default svg {
        width: ${parseInt(reviewsArrowSize) + 8}px !important;
        height: ${parseInt(reviewsArrowSize) + 8}px !important;
        font-size: ${reviewsArrowSize}px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-default.cf-reviews-prev {
        left: 0;
        transform: translateY(-50%) translateX(-50%);
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-default.cf-reviews-next {
        right: 0;
        transform: translateY(-50%) translateX(50%);
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-default:hover {
        background: #f8f8f8;
        border-color: #d0d0d0;
        color: #333;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-navigation-bottom {
        display: flex;
        align-items: center;
        margin-top: 30px;
        margin-left: auto;
        margin-right: auto;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-default .cf-reviews-navigation-bottom {
        justify-content: center;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-inline .cf-reviews-navigation-bottom {
        justify-content: space-between;
        width: 100%;
        ${containerWidth ? `max-width: 100%;` : `max-width: 1400px;`}
        margin-left: auto;
        margin-right: auto;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-inline .cf-reviews-navigation-single {
        justify-content: center !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-pagination {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-dot {
        width: 12px !important;
        height: 12px !important;
        border-radius: 50%;
        border: none;
        background: #d0d0d0;
        cursor: pointer;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-dot:hover {
        background: #a0a0a0;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-dot.active {
        background: #333;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrows-inline {
        display: flex;
        gap: 10px;
        align-items: center;
        flex-shrink: 0;
        margin-right: 0;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-inline {
        background: #ffffff;
        border: 2px solid #e5e5e5;
        border-radius: 50%;
        width: ${parseInt(reviewsArrowSize) + 20}px !important;
        height: ${parseInt(reviewsArrowSize) + 20}px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #666;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-inline svg {
        width: ${parseInt(reviewsArrowSize) + 8}px !important;
        height: ${parseInt(reviewsArrowSize) + 8}px !important;
        font-size: ${reviewsArrowSize}px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-inline:hover {
        background: #f8f8f8;
        border-color: #d0d0d0;
        color: #333;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-rating {
        font-size: 16px;
        display: flex;
        gap: 2px;
        ${reviewsInnerAlignmentFlex}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-rating svg {
        ${ratingStarColor ? `color: ${ratingStarColor} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-rating .svg-inline--fa {
        display: var(--fa-display, inline-block);
        height: 1em;
        overflow: visible;
        ${ratingStarSize ? `font-size: ${ratingStarSize}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-source-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-source-icon svg {
        width: 1em;
        height: 1em;
        ${sourceFontSize ? `font-size: ${sourceFontSize}px !important;` : 'font-size: 16px;'}
        vertical-align: middle;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video {
        position: relative;
        overflow: hidden;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video:not(.cf-reviews-video-inline) {
        width: 100%;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video::after {
        position: absolute;
        inset: 0;
        ${reviewsVideoOverlayColor ? `background: ${reviewsVideoOverlayColor} !important;` : ''}
        ${reviewsVideoOverlayColor ? `clip-path: inset(0 round 8px);` : ''}
        content: '';
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video iframe {
        width: 100%;
        height: 200px;
        border: none;
        border-radius: 8px;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video {
        position: relative;
        overflow: hidden;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-rating,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-rating .cf-reviews-star,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-rating svg,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-rating .svg-inline--fa,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-rating svg path {
        ${reviewsVideoBgRatingColor ? `color: ${reviewsVideoBgRatingColor} !important;` : ''}
        ${reviewsVideoBgRatingColor ? `fill: ${reviewsVideoBgRatingColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-title {
        ${reviewsVideoBgTitleColor ? `color: ${reviewsVideoBgTitleColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-content {
        ${reviewsVideoBgContentColor ? `color: ${reviewsVideoBgContentColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-customer-profile-name {
        ${reviewsVideoBgCustomerNameColor ? `color: ${reviewsVideoBgCustomerNameColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-customer-profile-title {
        ${reviewsVideoBgCustomerTitleColor ? `color: ${reviewsVideoBgCustomerTitleColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-date {
        ${reviewsVideoBgDateColor ? `color: ${reviewsVideoBgDateColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-source,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-source *,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-source-icon,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-background-video .cf-reviews-source-icon svg {
        ${reviewsVideoBgSourceColor ? `color: ${reviewsVideoBgSourceColor} !important;` : ''}
        ${reviewsVideoBgSourceColor ? `fill: ${reviewsVideoBgSourceColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-background-video-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        pointer-events: none;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-background-video-overlay .cf-reviews-video {
        height: 100%;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-background-video-overlay .cf-reviews-video iframe {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 0;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content-wrapper {
        position: relative;
        z-index: 2;
        display: flex;
        flex-direction: column;
        ${contentVerticalSpacing ? `gap: ${contentVerticalSpacing}px;` : ''}
        width: 100%;
        max-width: 100%;
        ${reviewsInnerAlignment}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-with-positioned-video {
        position: relative;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-layout-left,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-layout-right {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        align-items: flex-start;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-container {
        flex-shrink: 0;
        width: 200px;
        min-width: 200px;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-left {
        order: 1;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-right {
        order: 3;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-inline {
        order: initial;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-text-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        ${contentVerticalSpacing ? `gap: ${contentVerticalSpacing}px;` : ''}
        order: 2;
      }
    `;

    const reviewsArrowSizeMobile = options["reviews-arrow-size-mobile"] || reviewsArrowSize;

    const containerWidthMobile = options['reviews-container-width-mobile'];
    const containerHeightMobile = options['reviews-container-height-mobile'];
    const contentVerticalSpacingMobile = options['reviews-content-vertical-spacing-mobile'];
    const mobileReviewsPerSlide = parseInt(options['reviews-per-row-mobile']) || 1;
    const ratingStarSizeMobile = element.options["rating-star-size-mobile"];

    const titleFontSizeMobile = element.options["title-font-size-mobile"];
    const titleFontLineHeightMobile = element.options["title-font-line-height-mobile"];

    const contentFontSizeMobile = element.options["content-font-size-mobile"];
    const contentFontLineHeightMobile = element.options["content-font-line-height-mobile"];

    const customerProfileNameFontSizeMobile = element.options["customer-profile-name-font-size-mobile"];
    const customerProfileNameFontLineHeightMobile = element.options["customer-profile-name-font-line-height-mobile"];

    const customerProfileTitleFontSizeMobile = element.options["customer-profile-title-font-size-mobile"];
    const customerProfileTitleFontLineHeightMobile = element.options["customer-profile-title-font-line-height-mobile"];

    const dateFontSizeMobile = element.options["date-font-size-mobile"];
    const dateFontLineHeightMobile = element.options["date-font-line-height-mobile"];

    const sourceFontSizeMobile = element.options["source-font-size-mobile"];
    const sourceFontLineHeightMobile = element.options["source-font-line-height-mobile"];

    const customerProfileAvatarWidthMobile = element.options["customer-profile-avatar-width-mobile"];
    const customerProfileAvatarHeightMobile = element.options["customer-profile-avatar-height-mobile"];

    const brandLogoWidthMobile = element.options["brand-logo-width-mobile"];
    const brandLogoHeightMobile = element.options["brand-logo-height-mobile"];

    const videoWidthMobile = element.options["video-width-mobile"];
    const videoHeightMobile = element.options["video-height-mobile"];

    let reviewsInnerAlignmentMobile = "";
    let reviewsInnerAlignmentFlexMobile = "";
    let reviewsInnerAlignmentFlexItemsMobile = "";
    const innerAlignmentMobile = (options["cf-inner-alignment-mobile"] && options["cf-inner-alignment-mobile"].trim()) || 
                                  (options["cf-inner-alignment"] && options["cf-inner-alignment"].trim()) || 
                                  "left";
    if (innerAlignmentMobile === "left" || innerAlignmentMobile === "") {
      reviewsInnerAlignmentMobile = "text-align: left !important;";
      reviewsInnerAlignmentFlexMobile = "justify-content: flex-start !important;";
      reviewsInnerAlignmentFlexItemsMobile = "align-items: flex-start !important;";
    } else if (innerAlignmentMobile === "center") {
      reviewsInnerAlignmentMobile = "text-align: center !important;";
      reviewsInnerAlignmentFlexMobile = "justify-content: center !important;";
      reviewsInnerAlignmentFlexItemsMobile = "align-items: center !important;";
    } else if (innerAlignmentMobile === "right") {
      reviewsInnerAlignmentMobile = "text-align: right !important;";
      reviewsInnerAlignmentFlexMobile = "justify-content: flex-end !important;";
      reviewsInnerAlignmentFlexItemsMobile = "align-items: flex-end !important;";
    }

    let mobileStyles = `
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-element {
        ${containerWidthMobile ? `max-width: ${containerWidthMobile}px;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content-box {
        ${containerHeightMobile ? `min-height: ${containerHeightMobile}px;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-profile-avatar img {
        ${customerProfileAvatarWidthMobile ? `width: ${customerProfileAvatarWidthMobile}px !important;` : ''}
        ${customerProfileAvatarHeightMobile ? `height: ${customerProfileAvatarHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-brand-logo img {
        ${brandLogoWidthMobile ? `width: ${brandLogoWidthMobile}px !important;` : ''}
        ${brandLogoHeightMobile ? `height: ${brandLogoHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-profile-avatar img,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-brand-logo img {
        width: 100%;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-profile-title {
        text-align: left !important;
        ${customerProfileTitleFontSizeMobile ? `font-size: ${customerProfileTitleFontSizeMobile}px !important;` : ''}
        ${customerProfileTitleFontLineHeightMobile ? `line-height: ${customerProfileTitleFontLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-title,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content-type.cf-reviews-title {
        ${reviewsInnerAlignmentMobile}
        ${titleFontSizeMobile ? `font-size: ${titleFontSizeMobile}px !important;` : ''}
        ${titleFontLineHeightMobile ? `line-height: ${titleFontLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content {
        ${reviewsInnerAlignmentMobile}
        ${contentFontSizeMobile ? `font-size: ${contentFontSizeMobile}px !important;` : ''}
        ${contentFontLineHeightMobile ? `line-height: ${contentFontLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-profile-name {
        text-align: left !important;
        ${customerProfileNameFontSizeMobile ? `font-size: ${customerProfileNameFontSizeMobile}px !important;` : ''}
        ${customerProfileNameFontLineHeightMobile ? `line-height: ${customerProfileNameFontLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-date {
        ${dateFontSizeMobile ? `font-size: ${dateFontSizeMobile}px !important;` : ''}
        ${dateFontLineHeightMobile ? `line-height: ${dateFontLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-source {
        ${sourceFontSizeMobile ? `font-size: ${sourceFontSizeMobile}px !important;` : ''}
        ${sourceFontLineHeightMobile ? `line-height: ${sourceFontLineHeightMobile}px !important;` : ''}
        ${reviewsInnerAlignmentFlexMobile}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content-type {
        ${reviewsInnerAlignmentMobile}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content-wrapper {
        ${contentVerticalSpacingMobile ? `gap: ${contentVerticalSpacingMobile}px;` : ''}
        ${reviewsInnerAlignmentMobile}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-column-wrapper {
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: flex-start !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-customer-profile {
        ${reviewsInnerAlignmentFlexMobile}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-content-box {
        ${reviewsInnerAlignmentFlexItemsMobile}
        ${reviewsInnerAlignmentMobile}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-rating {
        ${reviewsInnerAlignmentFlexMobile}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-rating .svg-inline--fa {
        ${ratingStarSizeMobile ? `font-size: ${ratingStarSizeMobile}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-source-icon svg {
        ${sourceFontSizeMobile ? `font-size: ${sourceFontSizeMobile}px !important;` : 'font-size: 14px;'}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-inline,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-left,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-right {
        ${videoWidthMobile ? `width: ${videoWidthMobile}px !important;` : ''}
        ${videoHeightMobile ? `height: ${videoHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-horizontal .cf-reviews-grid {
        ${contentFlow === 'collage' ? `max-width: ${100 / mobileReviewsPerSlide}%; width: 100%;` : ''}
      }

      ${contentFlow === 'collage' ? `
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-horizontal.cf-reviews-slider-disabled .cf-reviews-grid {
        flex-direction: column;
        gap: 20px;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-horizontal.cf-reviews-slider-disabled .cf-reviews-content-box {
        width: 100% !important;
      }
      ` : ''}

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-horizontal .cf-reviews-content-box {
        width: ${contentFlow === 'collage' ? '100%' : `calc((100% - ${(mobileReviewsPerSlide - 1) * 20}px) / ${mobileReviewsPerSlide})`} !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-default .cf-reviews-slide-content {
        padding: 0 15px;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-inline .cf-reviews-slide-content {
        padding: 0;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-navigation-bottom {
        gap: 15px;
        margin-top: 25px;
        flex-wrap: wrap;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-inline .cf-reviews-navigation-bottom {
        flex-direction: column;
        align-items: center;
        gap: 15px;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-style-inline .cf-reviews-navigation-single {
        flex-direction: row !important;
        justify-content: center !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-default,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-inline {
        width: ${parseInt(reviewsArrowSizeMobile) + 20}px !important;
        height: ${parseInt(reviewsArrowSizeMobile) + 20}px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-default svg,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-arrow-inline svg {
        width: ${parseInt(reviewsArrowSizeMobile) + 8}px !important;
        height: ${parseInt(reviewsArrowSizeMobile) + 8}px !important;
        font-size: ${reviewsArrowSizeMobile}px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-vertical .cf-reviews-grid {
        flex-direction: column;
        gap: 20px;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-layout-vertical .cf-reviews-slide-content {
        flex-direction: column;
        gap: 20px;
      }

      /* Mobile video positioning adjustments */
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-layout-left,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-layout-right {
        flex-direction: column;
        gap: 15px;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video-container {
        width: 100%;
        min-width: auto;
        order: 1;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-text-content {
        order: 2;
        ${contentVerticalSpacingMobile ? `gap: ${contentVerticalSpacingMobile}px;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-reviews-video iframe {
        height: 180px;
      }
    `;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
